<template>
  <div class="input">
    <label>{{ label }}</label>
    <input type="number"
      v-bind:value="value"
      v-on:input="$emit('input', parseInt($event.target.value))" />
  </div>
</template>

<script>
export default {
  name: 'ProgressInput',
  props: {
    label: String,
    value: Number,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
  width: 3em;
  text-align: right;
}
</style>
